import { isEU } from '../../config/region';

/**
 * Feature flags for the top-level Drafting feature.
 *
 * DRAFTING_READ_ONLY - read-only drafting: no in-app editing and NO
 * collaborative (Yjs) socket. The document is viewed (markdown or DOCX preview)
 * and downloaded as Word; editing/collaboration is deferred.
 *
 * GATED TO EU for the first phase. On `eu.pons.io` drafting is VIEW-ONLY (the
 * Edit tab is hidden, `canEdit` is false, and the canvas can never enter edit
 * mode - a forced URL cannot re-open it). On dev/demo and every other host it
 * stays editable (single-user over REST while COLLAB_EDITING_ENABLED is off).
 * Region is read via `config/region.isEU()` - the same hostname signal the
 * sidebar and the other feature gates use; do not hand-roll a hostname check.
 * To make EU editable later, change this to `false` (or widen the predicate).
 */
export const DRAFTING_READ_ONLY = isEU();

/**
 * COLLAB_EDITING_ENABLED - real-time collaborative (Yjs) editing.
 *
 * When false (the default for the first release), the drafting editor runs as a
 * solid single-user editor: it opens the document locally and saves over REST,
 * and it NEVER opens the collaboration (Web PubSub / Yjs) socket. This lets us
 * ship clean, dependable editing without depending on the collaboration socket
 * being deployed and running.
 *
 * Flip to true once the collaboration socket (pons-socket) is live and its
 * `collaboration` hub is wired - real-time presence, cursors and co-editing then
 * turn on with no other change. This is deliberately a code-level flag (ships
 * and reverts with the code that reads it), not an env var.
 */
export const COLLAB_EDITING_ENABLED = false;

/**
 * DRAFTING_SHARING_ENABLED - sharing a drafted document with colleagues.
 *
 * The frontend is complete and is the same one Tables uses: the shared Access
 * pane (READ) plus the shared manage-access side panel (WRITE), over the
 * adapter contract in `utils/collaboratorAdapters/types`. What does not exist
 * yet is the BACKEND:
 *
 *   GET|POST   /drafting/{drafts|insights}/{uuid}/collaborators
 *   PUT|DELETE /drafting/{drafts|insights}/{uuid}/collaborators/{collabUuid}
 *
 * plus `shared_with` on the detail GET. Those mirror `/tables/:uuid/…` exactly,
 * so `accessModel.normalise` needs no new keys.
 *
 * OFF ships the page as it is: no Access pane, no rail pill, no avatar stack.
 * Flip this to `true` once those routes are deployed - nothing else changes.
 */
export const DRAFTING_SHARING_ENABLED = false;
